export default {
  loading: false,
  ordering: '',
  students: [],
  student: {}
}
